import { Text3D, useMatcapTexture, type Text3DProps } from '@react-three/drei'
import type { Ref } from 'react'
import type { Mesh } from 'three'

interface TitleText extends Omit<Text3DProps, 'font'> {
  ref?: Ref<Mesh>
}

export function TitleText({ ref, children, ...props }: TitleText) {
  const [matcap] = useMatcapTexture('7A7A7A_D9D9D9_BCBCBC_B4B4B4', 128)

  return (
    <Text3D
      ref={ref}
      {...props}
      font="/fonts/jetbrains-mono-bold.json"
      bevelEnabled
      bevelSize={0.03}
    >
      {children}
      <meshMatcapMaterial matcap={matcap} color="#0069a8" attach="material-0" />
      <meshMatcapMaterial matcap={matcap} color="white" attach="material-1" />
    </Text3D>
  )
}
